import { For, JSX } from "solid-js";
import { ModalInnerFrame, useModal } from "../modal";
import { PhosphorIcon } from "~/widgets/icons";

import { ButtonRegular } from "~/widgets/button";

export function HowItWorks() {
  const howHubbleCodesWork = [
    "Enter the code & click “Redeem”",
    "You’ll receive coins in wallet. 1 coin = ₹1",
    "Get the gift card of your choice using coins",
  ];

  return (
    <ModalInnerFrame>
      <div class="flex w-full flex-row items-start justify-between">
        <span class="text-nowrap text-h4 text-basePrimaryDark">
          How it works?
        </span>
        <CloseModalButton />
      </div>
      <div class="mt-5"></div>
      <ol class="flex flex-col gap-2">
        <For each={howHubbleCodesWork}>
          {(text, index) => (
            <li class="items flex flex-row items-center justify-start gap-2 text-basePrimaryDark darkTheme:text-baseSecondaryDark">
              <div class="flex h-[18px] w-[18px] items-center justify-center rounded-full border bg-baseTertiaryLight text-[10px] font-bold darkTheme:border-none darkTheme:bg-baseSecondaryLight">
                {index() + 1}
              </div>{" "}
              <span class="text-[15px] font-normal">{text}</span>
            </li>
          )}
        </For>
      </ol>
    </ModalInnerFrame>
  );
}

export function CloseModalButton(props: { onClick?: () => void }) {
  const { setIsModalOn, updateModalContentGetter } = useModal()!;

  return (
    <div
      id="close-modal-button"
      onClick={(event) => {
        event.stopPropagation();
        if (props.onClick) {
          props.onClick();
          return;
        }
        setIsModalOn(false);
        updateModalContentGetter(() => <></>);
      }}
    >
      <div class="flex h-8 w-8 cursor-pointer items-center justify-center rounded-[50%] border bg-baseTertiaryLight darkTheme:border-[#555] darkTheme:bg-[#222427] dark:border-basePrimaryLight dark:bg-basePrimaryDark">
        <PhosphorIcon
          name="x"
          size="bold"
          fontSize={16}
          class="text-basePrimaryDark dark:text-baseTertiaryLight"
        />
      </div>
    </div>
  );
}

export function ButtonDarkV2(props: {
  isLoading: boolean;
  onClick: () => void;
  children: JSX.Element;
}) {
  return (
    <ButtonRegular
      onClick={props.onClick}
      isEnabled={true}
      class="button-filled w-full"
      height="48px"
      isLoading={props.isLoading}
    >
      {props.children}
    </ButtonRegular>
  );
}
